import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import Checkbox from "../../../../componentLibrary/Checkbox";
import { ComponentI } from "../../../../types";
import Combobox from "../../../../componentLibrary/Combobox";
import Textarea from "../../../../componentLibrary/Textarea";
import {
  DEFAULT_END_TIME,
  DEFAULT_START_TIME,
} from "../../utils/addToCalendarDefaults";

const recurrenceOptions = [
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
  { label: "Yearly", value: "YEARLY" },
  { label: "None (One-time event)", value: "NONE" },
];

export default function AddToCalendarContentCard({
  component,
  handleContentChange,
  provided,
}: {
  component: ComponentI;
  handleContentChange: (
    id: string,
    field: string,
    value: string | boolean,
  ) => void;
  provided: DraggableProvided;
}) {
  return (
    <Card>
      <Input
        label="Event Title"
        value={component.content.eventTitle || ""}
        onChange={(e) =>
          handleContentChange(component._id, "eventTitle", e.target.value)
        }
        placeholder="e.g., Bedtime Reminder"
        required
        className="mb-2"
      />
      <Textarea
        label="Description"
        value={component.content.description || ""}
        onChange={(e) =>
          handleContentChange(component._id, "description", e.target.value)
        }
        placeholder="e.g., Time to start winding down for bed"
        rows={3}
        className="mb-2"
      />
      <div
        className="mb-2"
        data-rbd-drag-handle-context-id={
          provided.dragHandleProps?.["data-rbd-drag-handle-context-id"]
        }
        data-rbd-drag-handle-draggable-id={
          provided.dragHandleProps?.["data-rbd-drag-handle-draggable-id"]
        }
      >
        <Checkbox
          label="Add backlink to calendar description (toolbox or lesson link)"
          checked={component.content.addBacklink !== false}
          onChange={(e) =>
            handleContentChange(component._id, "addBacklink", e.target.checked)
          }
        />
      </div>
      <div className="grid grid-cols-2 gap-2 mb-2">
        <Input
          label="Start Time"
          type="time"
          value={component.content.startTime || ""}
          onChange={(e) =>
            handleContentChange(component._id, "startTime", e.target.value)
          }
          placeholder={DEFAULT_START_TIME}
          className=""
        />
        <Input
          label="End Time"
          type="time"
          value={component.content.endTime || ""}
          onChange={(e) =>
            handleContentChange(component._id, "endTime", e.target.value)
          }
          placeholder={DEFAULT_END_TIME}
          className=""
        />
      </div>
      <div
        className="space-y-2 mb-2"
        data-rbd-drag-handle-context-id={
          provided.dragHandleProps?.["data-rbd-drag-handle-context-id"]
        }
        data-rbd-drag-handle-draggable-id="add-to-calendar-interaction-area"
      >
        <div className="text-md font-semibold">Recurrence</div>
        <Combobox
          options={recurrenceOptions}
          value={
            recurrenceOptions.find(
              (opt) => opt.value === component.content.recurrence,
            ) || recurrenceOptions[0]
          }
          onChange={(option) =>
            handleContentChange(component._id, "recurrence", option.value)
          }
        />
      </div>
      <div className="text-xs text-gray-600 mt-2 p-2 bg-blue-50 rounded">
        <strong>Note:</strong> This button will allow users to add a calendar
        reminder. If start/end times are specified, they will be pre-filled in
        the calendar event. Otherwise, users can set the time when adding it to
        their calendar.
      </div>
    </Card>
  );
}
